module.exports = __webpack_public_path__ + "static/media/incorta-logo.55919d42.svg";